module.exports = __webpack_public_path__ + "img/jds.9346c5fd.gif";